import MicroModal from "https://cdn.skypack.dev/pin/micromodal@v0.4.10-jT92SEGT9FlWWoaAHtRN/mode=imports,min/optimized/micromodal.js";

export default function init() {
  const { body } = document;

  if (
    !body.classList.contains("countrycode-nz") ||
    !document.querySelector("#modal-blocker-nz")
  )
    return;

  MicroModal.show("modal-blocker-nz", {
    awaitCloseAnimation: true,
    onShow: function () {
      body.classList.add("util-Noscroll");
    },
    onClose: function () {
      body.classList.remove("util-Noscroll");
    },
  });
}
